export const useSealManageRouting = [
	{
    path: "/sealManage/useSealManage/list",
    name: "useSealManage-list",
    meta: { title: "用印管理" },
    component: () =>
      import(/* webpackChunkName: "useSealManage-list" */ "@/views/seal-management/useSealManage/list/index.vue"),
  },
	{
    path: "/sealManage/useSealManage/create",
    name: "useSealManage-create",
    meta: { title: "新建用印申请" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "useSealManage-create" */ "@/views/seal-management/useSealManage/form-create/index.vue"),
  },
	{
    path: "/sealManage/useSealManage/edit/:id",
    name: "useSealManage-edit",
    meta: { title: "编辑用印申请" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "useSealManage-edit" */ "@/views/seal-management/useSealManage/form-create/index.vue"),
  },
	{
    path: "/sealManage/useSealManage/detail/:id",
    name: "useSealManage-detail",
    meta: { title: "用印详情" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "useSealManage-detail" */ "@/views/seal-management/useSealManage/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/sealManage/useSealManage/flowPrint/:id",
    name: "useSealManage-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "useSealManage-flow-print" */ "@/views/seal-management/useSealManage/flow-print/index.vue"
      ),
  },
]